import { Center, Loader, Select, Title } from "@mantine/core";
import { useState } from "react";
import api from "../../../../../../api";
import { useSiteCategories } from "../../../../../../hooks/useSiteCategories";
import { useSiteNotifications } from "../../../../../../hooks/useSiteNotifications";
import { BasicConfirmationModal } from "../../../../../BuildingBlocks/Layout/Modals/BasicConfirmationModal/BasicConfirmationModal";
import "./ConfigurationConfirmationModal.scss";

type ConfigurationConfirmationModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  siteId: number;
  projectId?: string;
};

function ConfigurationConfirmationModal({
  onConfirm,
  onCancel,
  siteId,
  projectId
}: ConfigurationConfirmationModalProps) {
  const [isOpen, setIsOpen] = useState(true);
  const { data: siteNotifications, isLoading: siteNotificationsLoading } =
    useSiteNotifications(siteId);
  const { siteCategories, isLoading: siteCategoriesLoading } =
    useSiteCategories(projectId ?? null, {
      enabled: projectId !== undefined
    });
  const categoriesForSite = siteCategories?.find((site) => site.id === siteId);
  const isFullFeedin = categoriesForSite?.is_full_feedin;
  function handleClose() {
    setIsOpen(false);
  }
  function handleChangeGenerator(url: string, choice: string) {
    if (!url) return;
    return api.patch(url, { einspeisungsart: choice });
  }

  return (
    <BasicConfirmationModal
      className="ConfigurationConfirmationModal"
      confirmationButtonText="Konfiguration bestätigen"
      opened={isOpen}
      size="lg"
      title="Konfiguration bestätigen"
      toggleModal={handleClose}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      {siteNotificationsLoading || siteCategoriesLoading ? (
        <Center>
          <Loader />
        </Center>
      ) : !isFullFeedin &&
        !(siteNotifications?.generators_full_feedin?.length === 0) ? (
        <>
          <p>
            Bevor Sie die Konfiguration bestätigen, überprüfen Sie bitte in der
            folgenden Liste, ob jedem Erzeuger die richtige Einspeiseart
            zugeordnet ist. Die Einspeiseart können Sie je Erzeuger über das
            Dropdown Menü ändern.
          </p>
          <p>
            Bestätigen Sie abschließend Ihre Konfiguration. Ihr erster Schritt
            im Onboarding-Prozess ist damit bereits erledigt!
          </p>
          <div className="configuration-modal-generator-list-container">
            <Title my={20} order={5}>
              Erzeuger
            </Title>
            {siteNotifications?.generators_full_feedin?.map(
              (notification, index) => (
                <GeneratorEditElement
                  id={notification.id}
                  key={index}
                  name={notification.name}
                  url={notification.url}
                  onEdit={handleChangeGenerator}
                />
              )
            )}
          </div>
        </>
      ) : (
        <p>
          Wenn Sie den Status auf erledigt stellen, sind keine weiteren
          Änderungen ohne die Unterstützung vom Support-Team mehr möglich.
        </p>
      )}
    </BasicConfirmationModal>
  );
}

interface GeneratorEditElementProps {
  id: number;
  name: string;
  url: string;
  onEdit: (url: string, choice: string) => void;
}

function GeneratorEditElement({
  id,
  name,
  url,
  onEdit
}: GeneratorEditElementProps) {
  const generatorChoices = [
    { value: "Volleinspeisung", label: "Volleinspeisung" },
    {
      value: "TeileinspeisungEigenverbrauch",
      label: "Teileinspeisung (Eigenverbrauch)"
    }
  ];

  return (
    <div className="generator-edit-modal-container">
      <p>{name}</p>
      <Select
        data={generatorChoices}
        defaultValue={generatorChoices[0].value}
        id={"generator" + id}
        name={"generator" + id}
        onChange={(value: string | null) => {
          if (value) {
            onEdit(url, value);
          }
        }}
      />
    </div>
  );
}

export { ConfigurationConfirmationModal, ConfigurationConfirmationModalProps };
